module.exports = __webpack_public_path__ + "static/img/right_bg.f47836f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/right_bg.png
// module id = 8Hmm
// module chunks = 0